var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 35",
    style: {
      enableBackground: "new 0 0 170 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.5,33.9V0.4h7.8v28.4h8.5v5.1H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,30.6L31.6,30.6c-0.8,2.4-2.6,3.7-5.5,3.7c-3.3,0-5-2.3-5-6.2V7h7.4v18.7c0,1.2,0.1,2.4,1.5,2.4 s1.6-1.3,1.6-2.4V7H39v26.9h-7.4V30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.9,33.9h-6.6l4.5-14L40.5,7h7.7l2.3,10.4h0.1L52.9,7h6.6l-4.4,12.9l4.8,14h-7.8l-2.6-11.4h-0.1L46.9,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,21.3v5.5c0,1.6,0.6,2.6,1.6,2.6c1.2,0,1.6-1,1.6-2.6v-3.5h7.4v4c0,5.1-3.8,7-9,7c-4.8,0-9-2.2-9-7.2 V14.2c0-4.9,3.2-7.6,9-7.6c4.8,0,9,1.8,9,7.6v7.1H68.6z M71.7,16.8v-3.7c0-1-0.5-1.6-1.6-1.6c-1,0-1.6,0.6-1.6,1.6v3.7H71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,33.9V0.4H89v28.4h8.5v5.1H81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.6,27.1c0,5-4.2,7.2-9,7.2c-4.8,0-9-2.2-9-7.2V14.2c0-4.9,3.2-7.6,9-7.6s9,2.7,9,7.6V27.1z M106.1,27.5 c0,1,0.4,1.9,1.6,1.9c1.2,0,1.6-0.9,1.6-1.9v-14c0-1-0.4-1.9-1.6-1.9c-1.2,0-1.6,0.9-1.6,1.9V27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.7,27.1c0,5-4.2,7.2-9,7.2s-9-2.2-9-7.2V14.2c0-4.9,3.2-7.6,9-7.6c5.8,0,9,2.7,9,7.6V27.1z M126.2,27.5 c0,1,0.4,1.9,1.6,1.9c1.2,0,1.6-0.9,1.6-1.9v-14c0-1-0.4-1.9-1.6-1.9c-1.2,0-1.6,0.9-1.6,1.9V27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146,10.6L146,10.6c0.8-2.5,2.5-3.9,5.3-3.9c2.7,0,4.3,1.3,4.9,3.9h0.1c0.4-2.4,2.5-3.9,5.1-3.9 c3.7,0,4.9,2.4,4.9,5.7v21.6h-7.2V15.2c0-1.2-0.1-2.4-1.5-2.4c-1.4,0-1.5,1.3-1.5,2.4v18.7H149V15.2c0-1.2-0.1-2.4-1.5-2.4 c-1.4,0-1.5,1.3-1.5,2.4v18.7h-7.2V7h7.2V10.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.740cdb17199c2df69be873c2161e0831.svg";
export { ForwardRef as ReactComponent };